import React, { FC } from 'react';
import ReactHtmlParser from 'react-html-parser';
import parseUrlFn from 'components/twilio/utils/parseTextUrlToAnchor';

const TextMessage: FC<{ body: string}> = ({ body }) => (
  <>
    {ReactHtmlParser(parseUrlFn(body))}
  </>
);

export default React.memo(TextMessage);
